import { NotContainsSpecialCharacterError } from '../../validation/errors/not-contains-special-character-error'
import { type FieldValidation } from '../../validation/protocols/field-validation'

export class ContainsSpecialCharacterValidation implements FieldValidation {
  readonly field: string

  constructor (field: string) {
    this.field = field
  }

  validate (value: string): Error | null {
    if (value.length === 0) return null
    if (!value.match(/[^0-9A-Za-z]/g)) return new NotContainsSpecialCharacterError()
    return null
  }
}
